module.exports = __webpack_public_path__ + "src/assets/models/petri/blue_petri.fbx";